import * as moment from 'moment';
import { Moment } from 'moment';
import { Pais } from '.';
import { DocumentoPessoaEstrangeiraVO } from './documento-pessoa-estrangeira-vo.model';
import { Genero } from './genero.model';
import { Tipo } from './tipo.model';

export class PessoaEstrangeiraVO {
  id: number;
  idUnico: number;
  tipo: Tipo;
  nome: string;
  documentos: DocumentoPessoaEstrangeiraVO[] = [];
  dataNascimento: number;
  genero: Genero;
  email: string;
  nrDocumento?: string;
  pais?: Pais;

  constructor(init?: Partial<PessoaEstrangeiraVO>) {
    Object.assign(this, init);
  }

  get dataNascimentoMoment(): Moment {
    return moment(new Date(this.dataNascimento));
  }

  set dataNascimentoMoment(value: Moment) {
    this.dataNascimento = (value as Moment).toDate().getTime();
  }
}
